import formatDollar, { IOptions } from "./formatDollar";

const DOLLAR_IN_CENTS = 100;

export default function formatOgsDollar(amount: number, options?: IOptions): string {
    return formatDollar(amount / DOLLAR_IN_CENTS, options);
}



// WEBPACK FOOTER //
// ./src/utils/formatOgsDollar.ts